import { $axios } from '@/shared/api/axios'
import { ServerResponse } from '@/shared/types/common'

interface YaPayData {
	PAY_ID: string
	PAYMENT_TYPE: 'SPLIT'
}

export const fetchYaPayId = async () => {
	const { data } = await $axios.get<ServerResponse<YaPayData>>('pay/yandex')

	return data
}
